import { render, staticRenderFns } from "./formattedIncidentReportCommutingIncident.vue?vue&type=template&id=70c0ca58"
import script from "./formattedIncidentReportCommutingIncident.vue?vue&type=script&lang=js"
export * from "./formattedIncidentReportCommutingIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports